import React, { useEffect, useState } from "react";
import { ManualOrderCustomerSelection } from "../OrderManagement/manual/ManualOrderCustomerSelection";
import { Customer } from "hooks/CustomerManagement/useGetCustomerQuery";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Button from "Components/Button";
import { useGetOrderReport } from "hooks/Report/useGetOrderReport";
import { useGetCreditReport } from "hooks/Report/useGetCreditReport";

const CreditReports = () => {
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(
    null
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [payload, setPayload] = useState({});
  const [fetchReport, setFetchReport] = useState(false);

  const { RangePicker } = DatePicker;

  const { isLoading: isLoadingCreditReport, isSuccess } = useGetCreditReport(
    startDate,
    endDate,
    selectedCustomer?.id,
    status,
    fetchReport
  );

  const handleGenerateReport = () => {
    setFetchReport(true);
  };

  useEffect(() => {
    if (isSuccess) {
      setFetchReport(false);
    }
  }, [isSuccess]);

  const handleReset = () => {
    setPayload({});
    setEndDate("");
    setStartDate("");
    setSelectedCustomer(null);
  };

  return (
    <div className="p-[18px] rounded-[10px] bg-[#EEEEEE]">
      <h3 className="text-black text-[18px] font-bold flex gap-2">
        <Icon2 />
        Generate Credit Report
      </h3>
      <p className="text-grey mt-3">
        Proceed to filter by date or customer to complete the process
      </p>
      <RangePicker
        showTime
        disabled={isLoadingCreditReport}
        className={
          "mt-4 p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        }
        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
        onCalendarChange={(dates, dateStrings) => {
          if (dates && dates[0] && dates[1]) {
            const startDate = dates[0].format("YYYY-MM-DD");
            const endDate = dates[1].format("YYYY-MM-DD");

            setStartDate(startDate);
            setEndDate(endDate);

            setPayload({ ...payload, startDate, endDate });
          } else {
            setStartDate("");
            setEndDate("");
            setPayload({ ...payload, startDate: "", endDate: "" });
          }
        }}
      />
      <div className="flex flex-row gap-3 mb-3 text-[14px]">
        <span className="w-6/12">
          <h3 className="mb-2">Customer</h3>
          <ManualOrderCustomerSelection
            selectedCustomer={selectedCustomer}
            setSelectedCustomer={setSelectedCustomer}
          />
        </span>
        <span className="w-6/12">
          <h3 className="mb-2">Status</h3>
          <select
            className="p-2 rounded-md w-full"
            value={status}
            onChange={(e) => setStatus(e?.target?.value)}
            disabled={isLoadingCreditReport}
          >
            <option value="">Select Option</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="in_review">In Review</option>
            <option value="cancelled">Cancelled</option>
            <option value="repaid">Repaid</option>
          </select>
        </span>
      </div>
      {/* <div className="p-3 flex justify-between">
        <h3>Customer</h3>
        <ManualOrderCustomerSelection
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
        />
      </div> */}
      {/* <div className="p-3 flex items-center justify-between mb-3">
        <h3>Status</h3>
        <select
          className="w-[150px] p-2 rounded-md"
          value={status}
          onChange={(e) => setStatus(e?.target?.value)}
          disabled={isLoadingCreditReport}
        >
          <option value="">Select Option</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="in_review">In Review</option>
          <option value="cancelled">Cancelled</option>
          <option value="repaid">Repaid</option>
        </select>
      </div> */}
      <Button
        className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 ${
          startDate !== "" && endDate !== ""
            ? "bg-brown cursor-pointer"
            : "opacity-50 cursor-not-allowed"
        }`}
        disabled={startDate === "" || endDate === "" || isLoadingCreditReport}
        isLoading={isLoadingCreditReport}
        onClick={handleGenerateReport}
        label={"Generate"}
      />
      <button
        onClick={handleReset}
        className="mt-3 text-[12px] text-orange  p-2 rounded-md "
      >
        Reset
      </button>{" "}
    </div>
  );
};

export default CreditReports;

const Icon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
      />
    </svg>
  );
};
